import '@babel/polyfill'
import './plugins/vuetify'
import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'

import Loading from './components/Loading'
import store from './stores/store'
import '@mdi/font/css/materialdesignicons.css'
import './styles/main.styl'
import VModal from 'vue-js-modal'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import JsonExcel from 'vue-json-excel'

Vue.config.productionTip = false
Vue.component(Loading.name, Loading)
Vue.component('downloadExcel', JsonExcel)

Vue.use(VueAxios,axios)
Vue.use(VModal)
Vue.use(VueSweetalert2);

axios.interceptors.request.use(function (config) {
  store.state.loading.show() //vuex mutation set loading state to true
  return config;
  }, function (error) {
  return Promise.reject(error);
})
axios.interceptors.response.use(function (config) {
  store.state.loading.dialog = false //vuex mutation set loading state to false
  return config;
  }, function (error) {
  store.state.loading.dialog = false
  return Promise.reject(error);
})

let counter = 0;
axios.interceptors.response.use(function (config) {
  counter--
  if (counter == 0) {
    store.state.loading.dialog = false //vuex mutation set loading state to false
  }
  return config;
},
async function (error) {
  counter--
  if (counter == 0) {
    store.state.loading.dialog = false //vuex mutation set loading state to false
  }
  return Promise.reject(error);
})
//enter
Vue.directive('focusNextOnEnter', {
  inserted: function (el, binding, vnode) {
    let length = vnode.elm.length;
    vnode.elm[0].focus();
    let index = 0;
    el.addEventListener("keyup", (ev) => {
      if (ev.keyCode === 13 && index < length - 1) {
        if (vnode.elm[index].type != 'textarea') {
            index++;
          if(vnode.elm[index].readOnly==true||vnode.elm[index].disabled==true){
            index++;
          }
          vnode.elm[index].focus();
        }
      }
    });
    for (let i = 0; i < length - 1; i++) {
      vnode.elm[i].onfocus = (function (i) {
        return function () {
          if(vnode.elm[i+1].readOnly==true||vnode.elm[index].disabled==true){
            i++
          }
          index = i;
        }
      })(i);
    }
  }
})
Vue.directive('uppercase', {
  bind(el, _, vnode) {
    el.addEventListener('keyup', e => {
      e.target.value = e.target.value.toUpperCase()
      vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
    })
  }
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
